import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "typeface-yanone-kaffeesatz";
import App from './App';
import './i18n';
import { BrowserRouter as Router} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { FlowProvider } from './context/FlowContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <AuthProvider>
         <FlowProvider>
           <Router>
    <App />
    </Router>
      <ToastContainer position="bottom-right" />
    </FlowProvider>
    </AuthProvider>
  </React.StrictMode>
);